import { fetchImages } from "./image-container";
import { showCode } from "./show-code";

// -------------------------- Form Handling -------------------------- //

function disableForm(formElement) {
  const submitButton = formElement.querySelector("button[type='submit']");
  submitButton.setAttribute("disabled", "true");

  const selectElement = formElement.querySelector("select");
  selectElement.setAttribute("disabled", "true");
}

function enableForm(formElement) {
  const submitButton = formElement.querySelector("button[type='submit']");
  submitButton.removeAttribute("disabled");

  const selectElement = formElement.querySelector("select");
  selectElement.removeAttribute("disabled");
}

async function submitHandler(event) {
  event.preventDefault();

  const formElement = event.target;
  
  const formData = new FormData(formElement);
  const use = Object.fromEntries(formData);
  use.nrOfCols = Number(use.nrOfCols);
  use.nrOfRows = Number(use.nrOfRows);

  disableForm(formElement);

  showCode(use.method);
  await fetchImages(use.method, use.nrOfCols, use.nrOfRows);
  
  enableForm(formElement);
}

// -------------------------- Main Prgoram -------------------------- //
const form = document.querySelector("form");
form.addEventListener("submit", submitHandler);